<template>
  <div class="preview">
    <span class="d-hidden"> upload video </span>
    <div class="preview-video">
      <CustomPlayer
        :video_url="video_url"
        :is_autoplay="false"
        :video_source="video_source"
        :key="video_url"
      />
    </div>
    <div class="change-video-container">
      <span>
        <i
          class="fa fa-check-circle"
          aria-hidden="true"
        ></i>
        {{ name }}
      </span>

      <div
        class="change-button"
        role="button"
        @click="handleVideoUpload"
        :disabled="disabled"
      >
        Change video
      </div>
      <input
        type="file"
        name="file"
        id="file"
        class="d-none"
        accept="video/*"
        ref="changeRef"
        style="display: none"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import CustomPlayer from '../components/custom-player.vue';
export default {
  name: 'previewVideo',
  components: { CustomPlayer },
  props: {
    video_url: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    video_source: {
      type: String,
      required: false,
      default: 'local',
    },
  },
  data() {
    return {
      video: null,
      fileRef: null,
      props_video_url: '',
    };
  },
  mounted() {
    this.fileRef = this.$refs.changeRef;
    this.props_video_url = this.video_url;
  
  },
  methods: {
    handleVideoUpload() {
      this.fileRef.click();
      this.fileRef.addEventListener('change', (e) => {
        this.file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
          const videoUrl = event.target.result;
          this.props_video_url = videoUrl;
          this.$emit('handleVideoUpload', {
            file: this.file,
            videoUrl: videoUrl,
          });
        };
        reader.readAsDataURL(this.file);
      });
    },
  },
};
</script>

<style scoped>
.preview-video {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed rgb(243 243 249);
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
}
.preview span {
  font-size: 20px;
  font-weight: 600;
  color: #000;
  margin-bottom: 10px;
}

.change-video-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: 1px solid #f3f3f9;
  margin-top: 19px;
  background: #ffffff;
  border-radius: 5px;
}

.change-video-container span {
  font-size: 10px;
  font-weight: 600;
  color: #617081;
  padding: 4px;
  margin-bottom: 0px;
  text-wrap: nowrap;
  width: 139px;
  overflow: hidden;
}
.change-video-container i {
  margin-right: 5px;
  margin-left: 5px;
}

.change-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-left: 1px solid #f3f3f9;
  transition: all 0.3s;
  &:hover {
    cursor: pointer;
    background: #e6e6f1;
  }
}
</style>
